import i18n from "i18next";
import { initReactI18next } from "react-i18next"; // https://react.i18next.com/latest/using-with-hooks
import Backend from "i18next-http-backend"; // For lazy loading for translations: https://github.com/i18next/i18next-http-backend
import detector from "i18next-browser-languagedetector"; // For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector

i18n
    .use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init({
        supportedLngs: ["fr", "en"],
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json", // locale files path
        },
        ns: ["common"],
        defaultNS: "common",
        fallbackLng: ["fr", "en"],
        lng: 'fr',
        interpolation: {
            // React already escapes rendered values. Leaving i18next's own
            // escaping on turns interpolated dates ("14/04/2026") into
            // "14&#x2F;04&#x2F;2026" when rendered as JSX text.
            escapeValue: false,
        },
    });

export default i18n;